import {Component, OnInit, Input, Output, EventEmitter, Inject} from '@angular/core';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})

export class DialogComponent implements OnInit {
  @Input() titleText: string;
  @Input() buttonText: string[];
  @Input () type = 'alert'; // alert or confirm
  @Input() src = '';
  @Input() icon = false;
  @Input() dialogClass = '';
  @Output() approveCallback = new EventEmitter();
  @Output() dismissCallback = new EventEmitter();
  @Output() closeCallback = new EventEmitter();

  public approveText: string;
  public dismissText: string;

  // @Inject(MODAL_DATA_VAR) data: any
  constructor() {
    // this.titleText = data.titleText;
  }
  ngOnInit() {
    if (this.buttonText){
      this.approveText = this.buttonText[0];
      this.dismissText = this.buttonText[1] || null;
    }
  }

  approve(): void {
    this.approveCallback.emit();
  }

  dismiss(): void {
    this.dismissCallback.emit();
  }
  closeDialog(){
    this.closeCallback.emit();
  }
}
